"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ajvForModels = void 0;
var ajvConfig_1 = require("./ajvConfig");
Object.defineProperty(exports, "ajvForModels", { enumerable: true, get: function () { return ajvConfig_1.ajvForModels; } });
__exportStar(require("./model"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBLHlDQUEwQztBQUFqQyx5R0FBQSxZQUFZLE9BQUE7QUFDckIsMENBQXVCIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgYWp2Rm9yTW9kZWxzIH0gZnJvbSBcIi4vYWp2Q29uZmlnXCJcbmV4cG9ydCAqIGZyb20gXCIuL21vZGVsXCJcbiJdfQ==